var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseWrapper',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"flex justify-end mb-4"},[_c('BaseSelect',{attrs:{"shadow":false,"options":[
        {
          key: 'diproses_gudang_pengeluaran',
          label: 'Diproses Gudang Pengeluaran',
          value: 'diproses_gudang_pengeluaran'
        },
        {
          key: 'diproses_gudang_pengiriman',
          label: 'Diproses Gudang Pengiriman',
          value: 'diproses_gudang_pengiriman'
        },
        {
          key: 'ada_susulan',
          label: 'Ada Susulan',
          value: 'ada_susulan'
        },
        {
          key: 'selesai',
          label: 'Selesai',
          value: 'selesai'
        }
      ]},on:{"change":_vm.loadOrders},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1),_c('Datatable',{attrs:{"columns":_vm.columns},scopedSlots:_vm._u([{key:"tbody",fn:function({ classes }){return _vm._l((_vm.orders.data),function(order){return _c('tr',{key:order.id,class:[classes.tr, 'bg-white cursor-pointer hover:bg-gray-50'],on:{"click":function($event){_vm.$router.push({ name: 'gudang.reimbursement.create', params: { id: _vm.getOrder(order).id } })}}},[_c('td',{class:classes.td},[_c('OrderCodeLabel',{attrs:{"order":_vm.getOrder(order)}}),_c('OrderDateLabel',{staticClass:"text-xs text-gray-500",attrs:{"order":order}})],1),_c('td',{class:classes.td},[_vm._v(" "+_vm._s(_vm.getOrder(order).attributes.origin_office_code)+" ")]),_c('td',{class:classes.td},[_vm._v(" "+_vm._s(_vm.getOrder(order).attributes.reimbursement_qty)+" ")]),_c('td',{class:[classes.td, 'text-center']},[_c('BaseBadge',{attrs:{"color":"blue"}},[_vm._v(_vm._s(_vm.getOrder(order).attributes.reimbursement_status_label ?? 'Diproses Gudang Reimbursement'))])],1)])})}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }